import "./CheckOutPage.css";
import UnifiedCheckout from "../../Components/CheckOut/UnifiedCheckout";
import product_banner from '../../assets/images/desktopImage_4_banner.jpg'
import product_banner_mobile from '../../assets/images/mobileImage_4.jpg'
import CommonBanner from "../../common/CommonBanner/CommonBanner";
import SEO from "../../common/SEO/SEO";

const CheckOutPage = () => {
  return (
    <>
      <SEO title="Secure Checkout" noindex={true} />
      <CommonBanner product_banner={product_banner} product_banner_mobile={product_banner_mobile} title="Secure Checkout"  />
      <div className="container">      
        <div className="checkout_page">
          <UnifiedCheckout />
        </div>
      </div>
    </>
  );
};

export default CheckOutPage;
